import React from 'react';
import {Link} from 'react-router';
import { Dialog } from "@blueprintjs/core";

class ConfirmDialog extends React.Component {
  closeDialog() {
    this.props.onClose();
  }

  onSuccess() {
    this.props.onSuccess();
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.open}
        onClose={this.closeDialog.bind(this)}
        title={this.props.title}
        className="reception-dialog delete-dialog wrap-block"
        >
        <div className="pt-dialog-body">
          <p className="reception-dialog-text">{this.props.content}</p>
        </div>
        <div className="box-bottom col-100">
          <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
          <Link className="btn-green" onClick={this.onSuccess.bind(this)}><span>Đồng ý</span></Link>
        </div>
      </Dialog>
    );
  }
}

ConfirmDialog.defaultProps = {
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function () {
    console.log('Need to assign onSuccess method');
  },
  onClose: function () {
    console.log('Need to assign onClose method');
  }
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ConfirmDialog.jsx